import styled from 'styled-components';
import { Button, StyledInput, FieldLabel } from './CardModal.styles'; // Reusing some styles

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050; // Ensure it's above CardModal
`;

export const ModalContent = styled.div`
  background: #2C333A; // Slightly different from CardModal's main content for distinction
  padding: 24px;
  border-radius: 8px;
  width: 480px;
  max-width: 90%;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
  color: #B6C2CF;
`;

export const ModalHeader = styled.h3`
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
`;

export const StyledFormInput = styled(StyledInput)`
  // Inherits from CardModal.styles.js, can add overrides if needed
  margin-bottom: 0; // Remove default margin from StyledInput if FormGroup handles it
`;

export const StyledSelect = styled.select`
  width: 100%;
  padding: 10px 12px;
  border-radius: 3px;
  background: #22272B;
  color: #B6C2CF;
  border: 1px solid #3B444C;
  font-size: 14px;
  line-height: 1.5;

  &:focus {
    outline: 2px solid #4c9aff;
    border-color: #4c9aff;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const SaveButton = styled(Button)`
  // Inherits from CardModal.styles.js
`;

export const CancelButton = styled(Button)`
  // Inherits from CardModal.styles.js
  background: #6c757d; // Grey color for cancel

  &:hover {
    background: #5a6268;
  }
`;

export { FieldLabel }; // Exporting reused FieldLabel
